// The subaccount tag's place in the wholesale flow save, extracted pure so the rule is
// unit-tested (sub-auth-id-for-save.test.ts) instead of buried in usePublishFlow.
//
// The tag is an identity/billing field, so it must never ride a save by accident. The
// payload carries `phlo.sub_auth_id` ONLY when the user changed it in this session — the
// staged value on agentSettings differs from the tag the canvas was loaded with. Otherwise
// the key is left out entirely: config-service treats an absent key as "no change", so a
// canvas-only save can never untag a flow — not from a user whose org has the feature
// hidden, and not from a stale client that loaded the flow before another admin tagged it.
// An explicit "Main account" pick still sends null, which is the one way to untag.
export interface SubAuthIdForSaveInput {
  // What agentSettings holds: undefined = nothing staged (not seeded yet, or a partial
  // merge without the key), null = explicitly untagged, string = a subaccount.
  stagedSubAuthId: string | null | undefined
  // The tag on flowData.phlo when the canvas was loaded (the server's last answer).
  loadedSubAuthId: string | null | undefined
}

export const subAuthIdPayloadPart = ({
  stagedSubAuthId,
  loadedSubAuthId,
}: SubAuthIdForSaveInput): { sub_auth_id?: string | null } => {
  if (stagedSubAuthId === undefined) return {}
  const staged = stagedSubAuthId ?? null
  const loaded = loadedSubAuthId ?? null
  return staged === loaded ? {} : { sub_auth_id: staged }
}
